import type { SsoConfigFormState } from './SsoConfigForm';
import { MASKED_SECRET } from './types';
import type { SsoConfig } from './types';

/**
 * Build the editable SSO form state from a stored config (or a blank default
 * when none exists). Kept in its own module so the component file only exports
 * components (Vite fast-refresh constraint).
 */
export function formFromConfig(config: SsoConfig | null): SsoConfigFormState {
  if (!config) {
    return {
      name: '',
      provider: 'pingone',
      discoveryUrl: '',
      clientId: '',
      clientSecret: '',
      scopesRaw: 'openid, profile, email',
      domainsRaw: '',
      pingOneRegion: '',
      pingOneEnvironmentId: '',
      isEnabled: false,
      emailClaim: '',
      rolesClaim: '',
      locationsClaim: '',
    };
  }
  return {
    name: config.name,
    provider: config.provider,
    discoveryUrl: config.discoveryUrl ?? '',
    clientId: config.clientId,
    // Show the masked literal so the operator sees a secret is stored.
    // buildPatchPayload drops this from the PATCH.
    clientSecret: MASKED_SECRET,
    scopesRaw: (config.scopes ?? []).join(', '),
    domainsRaw: (config.domains ?? []).join(', '),
    pingOneRegion: config.pingOneRegion ?? '',
    pingOneEnvironmentId: config.pingOneEnvironmentId ?? '',
    isEnabled: config.isEnabled,
    emailClaim: config.attributeMapping?.email ?? '',
    rolesClaim: config.attributeMapping?.roles ?? '',
    locationsClaim: config.attributeMapping?.locations ?? '',
  };
}
